import React from 'react'
import { Link } from 'react-router-dom'
import "./OffterSection.scss"
export default function OffterSection({data, title}) {
    console.log(data) 
    return ( 
        <div className="offer-brand-wrapper">
            {/* <div className="container"> */}
            <div className="offer-brand-content">
                <h4 className="section-title">{title}</h4>
                <div className="offer-card-wrapper"> 
                    {data.map(offer => 
                    <Link key={offer.id} to={`/offers/${offer.id}/${offer.name}`} className="offer-card">
                        <h4 className="offer-subtitle">{offer.name}</h4> 
                        {/* <h3 className="free-title">{localization.FREE[currentLang]}</h3> */}
                        {/* <h6 className="offer-section">Cosmetics products</h6> */}
                    </Link>
                        )}
                    {/* <Link to="/offers" className="offer-card">
                        <h4 className="offer-subtitle">Buy 1 and Get 1</h4>
                        <h3 className="free-title">FREE</h3>
                    </Link>
                    <Link to="/offers" className="offer-card red-bg">
                        <h4 className="offer-subtitle">Buy 1 and Get 1</h4> 
                        <h3 className="free-title">FREE</h3>
                        <h6 className="offer-section">Clothes</h6>
                    </Link> */}
                </div>
                </div>
            {/* </div> */}
        </div>
    )
}
